import { render, staticRenderFns } from "./campign-description-form.vue?vue&type=template&id=5ad7e39c&scoped=true&"
import script from "./campign-description-form.vue?vue&type=script&lang=js&"
export * from "./campign-description-form.vue?vue&type=script&lang=js&"
import style0 from "./campign-description-form.vue?vue&type=style&index=0&id=5ad7e39c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad7e39c",
  null
  
)

export default component.exports